import { origin, rootUrl } from '~/api/Services';

export const getFullImagePath = (image: string = '') => {

  if (image === null) return '';

  if (image.startsWith('http')) {
    return image;
  }

  if (image.startsWith('assets')) {
    return `${origin}/${image}`;
  }

  return `${rootUrl}${image}`;
};
